module.exports = __webpack_public_path__ + "img/standard-box.0650135b.png";